var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"router-transition"}},[_c('router-view')],1),_vm._v(" "),_c('nav',{staticClass:"app-nav"},[_c('router-link',{attrs:{"to":"/impressum"}},[_vm._v("Impressum")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/datenschutz"}},[_vm._v("Datenschutzerklärung")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bac5302","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 